import { useQuery } from '@tanstack/react-query'
import { developersApi } from '@/lib/api'

/**
 * Hook for fetching all developers with their profiles and skills
 */
export function useDevelopers() {
  return useQuery({
    queryKey: ['developers'],
    queryFn: async () => {
      const response = await developersApi.getAll()
      return response.data
    },
  })
}
